import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteHubspotCompany } from './types';

// The live HubSpot company behind a quote (null when none is associated). Read on demand for the
// quote detail page — never stored — so we hit HubSpot on each load.
export function useBillingQuoteHubspotCompany(quoteId: string | null) {
  const { data, error, isLoading, mutate } =
    useSWR<TBillingQuoteHubspotCompany | null>(
      quoteId ? `commenda-billing/quotes/${quoteId}/hubspot-company` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { hubspotCompany: data ?? null, error, isLoading, mutate };
}
